import { itemsPagination, listLoadingProgress, loadingProgress } from '~/data/reducers/reports';
import * as schemas from '~/data/utils/schemas';
import { Map } from 'immutable';
import { denormalize } from 'normalizr';

const getState = (store) => store.reports;

const getEntities = (store) => getState(store).get('entities');

export const getItem = (store, id) => getEntities(store).get(id);

export const getItems = (store) => {
  const entities = Map({
    reports: getEntities(store),
  });
  return denormalize(itemsPagination.getPageItems(getState(store)), [schemas.report], entities);
};

export const itemLoaded = (store) => loadingProgress.getLoaded(getState(store));

export const itemsLoaded = (store) => listLoadingProgress.getLoaded(getState(store));

export const getTotalItems = (store) => itemsPagination.getTotalItems(getState(store));
